module.exports = __webpack_public_path__ + "static/media/RemoveItem.1e39149c.gif";